import * as React from "react";
import MultiSelectBadges from "ui/components/multiselect-badge";
import { readItem, readItems } from "@directus/sdk";
import client from "directus/src/client";

export default function EvtMultiSelectBadges({
  collection,
  values = [],
  onChange,
  fields = ["id", "name"],
  searchKeys = ["name"],
  filter: baseFilter,
  createSearchFilter,
  limit = 20,
  sort,
  page,
  offset,
  meta,
  deep,
  query = {},
  listRequest,
  itemRequest,
  mapItem,
  valueKey = "id",
  // UI
  searchable = true,
  placeholder = "Select...",
  searchPlaceholder = "Search...",
  ...uiProps
}) {
  const [search, setSearch] = React.useState("");
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const collectionKey = String(collection || "");
  const listReq = listRequest || ((q) => readItems(collectionKey, q));
  const itemReq = itemRequest || ((id, q) => readItem(collectionKey, id, q));

  React.useEffect(() => {
    let ignore = false;
    async function run() {
      setLoading(true);
      try {
        const buildDefaultSearchFilter = (term, keys) => {
          if (!term) return undefined;
          const s = String(term).trim();
          if (!s) return undefined;
          return {
            _or: keys
              .filter((k) => k !== "id")
              .map((k) => ({ [k]: { _icontains: s } })),
          };
        };

        const searchFilter = search
          ? createSearchFilter?.(search, { fields, searchKeys }) ||
            buildDefaultSearchFilter(search, searchKeys)
          : undefined;

        const finalFilter =
          baseFilter && searchFilter
            ? { _and: [baseFilter, searchFilter] }
            : baseFilter || searchFilter || undefined;

        const listQuery = {
          ...query,
          fields,
          ...(finalFilter ? { filter: finalFilter } : {}),
          ...(typeof limit === "number" ? { limit } : {}),
          ...(sort ? { sort } : {}),
          ...(typeof page === "number" ? { page } : {}),
          ...(typeof offset === "number" ? { offset } : {}),
          ...(meta ? { meta } : {}),
          ...(deep ? { deep } : {}),
        };
        const list = await client.request(listReq(listQuery));
        if (!ignore) setItems(Array.isArray(list) ? list : []);
      } finally {
        if (!ignore) setLoading(false);
      }
    }
    if (client && collectionKey) run();
    return () => {
      ignore = true;
    };
  }, [
    client,
    collectionKey,
    search,
    JSON.stringify(baseFilter),
    JSON.stringify(fields),
    JSON.stringify(searchKeys),
    limit,
    JSON.stringify(sort),
    page,
    offset,
    JSON.stringify(meta),
    JSON.stringify(deep),
    JSON.stringify(query),
    createSearchFilter,
  ]);

  return (
    <MultiSelectBadges
      data={items}
      mapItem={mapItem}
      valueKey={valueKey}
      values={values}
      onChange={onChange}
      searchable={searchable}
      search={search}
      onSearch={setSearch}
      isLoading={loading}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      fetchSelected={async (v) => client.request(itemReq(v, { fields }))}
      {...uiProps}
    />
  );
}

export function EvtDepartmentMultiselect(props) {
  return (
    <EvtMultiSelectBadges
      {...props}
      collection="departments"
      fields={["id", "name"]}
      searchKeys={["name"]}
    />
  );
}
